export default __webpack_public_path__ + "static/media/backer-mb.78091cb6.webp";